import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useMemo } from "react";
import { isEmpty, map } from "lodash";
import { CreateCampaignAwardedData } from "../../../types/campaignAwarded";

export function Review() {
  const formik = useFormikContext<CreateCampaignAwardedData>();

  const errors = useMemo(() => {
    const errorsFormik = Object.values(formik.errors);
    return errorsFormik as string[];
  }, [formik.errors]);

  const target = useMemo(() => {
    if (formik.values.public === "insight") {
      return formik.values.target?.nameList;
    } else {
      return formik.values.target?.nameForm;
    }
  }, [formik.values.target, formik.values.public]);

  const spublic = useMemo(() => {
    if (formik.values.public === "form") {
      return "Formulários";
    } else {
      return "Audiências";
    }
  }, [formik.values.public]);

  return (
    <Stack spacing={4}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography color="primary">Resumo</Typography>
      </Stack>
      {!isEmpty(errors) && (
        <>
          <Stack spacing={1}>
            <Typography>Erros na campanha</Typography>
            {map(errors, (error) => {
              return (
                <Typography variant="button" color="red">
                  {error}
                </Typography>
              );
            })}
          </Stack>
        </>
      )}

      <Typography>Ação: {formik.values.action}</Typography>
      <Typography>Nome: {formik.values.name}</Typography>
      <Typography>Público: {spublic}</Typography>
      <Typography>Alvo: {target}</Typography>
      <Typography>Pessoas premiadas: {formik.values.top_ranking}</Typography>
    </Stack>
  );
}
